import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';

export const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/lounge', label: 'DIAMOND CLUB LOUNGE' },
    { path: '/apply', label: 'APPLY PRIVATELY' },
    { path: '/meet-the-team', label: 'MEET THE TEAM' },
    { path: '/testimonials', label: 'TESTIMONIALS' },
    { path: '/press', label: 'PRESS' },
  ];
  
  const isActive = (path) => location.pathname === path;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-black-deep/90 backdrop-blur-sm border-b border-gold/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="block" onClick={closeMobileMenu}>
              <img 
                src="https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/vdch59ia_Diamond%20Club%20Header.png"
                alt="Diamond Club Matchmaking"
                className="h-12 md:h-14 w-auto object-contain"
              />
            </Link>
            
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-sans text-xs tracking-[0.15em] uppercase transition-colors duration-300 ${
                    isActive(link.path)
                      ? 'text-gold'
                      : 'text-cream hover:text-gold'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
            
            {/* Mobile menu button */}
            <button 
              className="lg:hidden text-cream hover:text-gold transition-colors p-2"
              onClick={toggleMobileMenu}
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {mobileMenuOpen ? (
                <X className="w-6 h-6" strokeWidth={1.5} />
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
            
            {/* Right spacer for balance */}
            <div className="hidden lg:block w-32"></div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/60 lg:hidden"
          onClick={closeMobileMenu}
        />
      )}

      {/* Mobile Menu Panel */}
      <div 
        className={`fixed top-20 left-0 right-0 z-45 bg-black-deep border-b border-gold/20 lg:hidden transform transition-transform duration-300 ease-in-out ${
          mobileMenuOpen ? 'translate-y-0' : '-translate-y-full'
        }`}
        style={{ zIndex: 45 }}
      >
        <nav className="flex flex-col py-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={closeMobileMenu}
              className={`font-sans text-sm tracking-[0.15em] uppercase py-4 px-6 transition-colors duration-300 border-b border-gold/10 last:border-b-0 ${
                isActive(link.path)
                  ? 'text-gold bg-gold/5'
                  : 'text-cream hover:text-gold hover:bg-gold/5'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Header;
